import { FIELDS, TAB_VIEW_SECTIONS, TABS } from '../../constants';

export const { OVERVIEW } = TABS;
export const { PROPERTY_DETAILS } = TAB_VIEW_SECTIONS[OVERVIEW];
export const { [PROPERTY_DETAILS]: PROPERTY_DETAILS_FIELDS } = FIELDS[OVERVIEW];

export const TRANSFER_PRIMARY_BUTTON_TEXT = 'Transfer Property';
export const LEASING_TEAM_PUBLIC_ID = 'leasingTeamPublicId';
export const DEFAULT_MANAGER_OWNER_USERNAME = 'defaultManagerOwnerUsername';

export const TRANSFER_LABELS = {
  [LEASING_TEAM_PUBLIC_ID]: 'Leasing Team Public ID',
  [DEFAULT_MANAGER_OWNER_USERNAME]: 'Default Owner Username',
};

export const VALIDATION_ERROR_MESSAGES = {
  [LEASING_TEAM_PUBLIC_ID]: `${TRANSFER_LABELS[LEASING_TEAM_PUBLIC_ID]} is required.`,
  [DEFAULT_MANAGER_OWNER_USERNAME]: `${TRANSFER_LABELS[DEFAULT_MANAGER_OWNER_USERNAME]} is required.`,
};
